import {
  distance,
  gaussianRandom,
  standardDeviation,
  chiPDF,
  weibullPDF,
  calculateCEPRayleigh,
  mannWhitneyTest,
  getFurthestDistance,
  tTest,
  fTest
} from './stats.js'

export function drawVectors(canvas, ctx, sources, count, scale, allPoints, draw = true) {
  const colors = [
    "#FF5733", // vibrant orange.
    "#116466", // deep teal.
    "#2C3E50", // navy blue.
    "#8E44AD", // royal purple.
    "#F1C40F", // golden yellow.
    "#E74C3C", // bright red.
    "#2ECC71", // vibrant green.
    "#3498DB", // bright blue.
    "#9B59B6", // muted purple.
    "#34495E", // dark blue.
    "#A3E4D7", // soft turquoise.
    "#F39C12", // burnt orange.
    "#7FB3D5", // light sky blue.
  ]

  ctx.clearRect(0, 0, canvas.width, canvas.height);

  for (let n = 0; n < count; ++n) {
    let previousX = 0
    let previousY = 0

    for (let i = 0; i < sources.length; i++) {
      const source = sources[i]
      const direction = source.direction
      let x1, y1
      if (direction === 'vertical') {
        x1 = previousX
        y1 = previousY + gaussianRandom(+source.value, 0);
      } else if (direction === 'horizontal') {
        x1 = previousX + gaussianRandom(+source.value, 0);
        y1 = previousY
      } else {
        let angle = Math.random() * 2 * Math.PI;
        let length = gaussianRandom(+source.value, 0);
        x1 = previousX + length * Math.cos(angle);
        y1 = previousY + length * Math.sin(angle);
      }
      if (draw && n === count - 1) {
        ctx.beginPath();
        ctx.moveTo((previousX * scale) + canvas.width / 2, (previousY * scale) + canvas.height / 2);
        ctx.lineTo((x1 * scale) + canvas.width / 2, (y1 * scale) + canvas.height / 2);
        ctx.strokeStyle = colors[i % colors.length]; // set strokeStyle to the ith color in the array
        ctx.lineWidth = 2
        ctx.stroke();
        ctx.lineWidth = 1
      }
      previousX = x1;
      previousY = y1;
      if (i === sources.length - 1) {
        allPoints.push({x: x1, y: y1});
      }
    }
  }

  if (!draw) return

  // Draw all previous points
  ctx.fillStyle = '#ff0000'
  for (let i = 0; i < allPoints.length; i++) {
    ctx.beginPath();
    ctx.arc(allPoints[i].x * scale + canvas.width / 2, allPoints[i].y * scale + canvas.height / 2, 1, 0, 2 * Math.PI);
    ctx.fill();
  }

  // Calculate average distance
  let sumDistance = 0;
  let maxBox = 0;
  let boxes = {}
  const boxDelta = .02
  for (let i = 0; i < 10; i += boxDelta) {
    boxes[i.toFixed(3)] = 0
  }
  const dists = []
  const xdists = []
  const ydists = []
  for (let i = 0; i < allPoints.length; i++) {
    let dist = distance(allPoints[i].x, allPoints[i].y, 0, 0)
    dists.push(dist)
    xdists.push(allPoints[i].x)
    ydists.push(allPoints[i].y)
    sumDistance += dist;
    const box = (Math.floor((dist) * (1 / boxDelta)) / (1 / boxDelta)).toFixed(3)
    if (!boxes[box]) boxes[box] = 0
    boxes[box] += 1
    maxBox = Math.max(maxBox, box)
  }
  for (let i = maxBox + boxDelta; i < 10; i += boxDelta) {
    delete boxes[i.toFixed(3)]
  }

  let runningTotal = 0
  let fiftyPercentBox = 0
  let ninetyFivePercentBox = 0
  Object.keys(boxes).forEach(box => {
    runningTotal += boxes[box]
    if (runningTotal / allPoints.length <= .5) {
      fiftyPercentBox = box
    }
    if (runningTotal / allPoints.length <= .95) {
      ninetyFivePercentBox = box
    }
  })
  //console.log({ ninetyFivePercentBox, fiftyPercentBox })

  const averageDistance = sumDistance / allPoints.length;

  //dists.sort((a, b) => a - b)
  const sd = standardDeviation(dists, 0)

  const keys = [ ...Object.keys(boxes).reverse().filter(v => parseFloat(v) !== 0), ...Object.keys(boxes) ]
  const boxWidth =  canvas.width / keys.length
  const boxMax = Math.max.apply(Math, Object.values(boxes))
  for (let i = 0; i < keys.length; ++i) {
    ctx.beginPath();
    ctx.rect(i * boxWidth + 1, canvas.height, boxWidth - 1, 100 * (-boxes[keys[i]] / boxMax))
    //const area = Math.abs(Math.PI * Math.pow(keys[i], 2) - Math.PI * Math.pow(keys[i + 1], 2))
    //ctx.rect(i * boxWidth + 1, canvas.height, boxWidth - 1, (100 * (-boxes[keys[i]] / boxMax)) / (area * 300))
    ctx.fillStyle = keys[i] >= ninetyFivePercentBox ? 'red' : (keys[i] >= fiftyPercentBox ? '#007bff' : 'green')
    ctx.fill()
  }

  /*
  let minError = Math.min()
  let bestScale
  let bestK
  for (let k = 1; k <= 2; k += .001) {
    for (let i = .5; i <= 1.5; i += .001) {
      const e = (drawCurve('#000000', keys, false, value => {
        return weibullPDF(value / sd, i, k)
      }))
      //console.log(i, e)
      if (e < minError) {
        minError = e
        bestScale = i
        bestK = k
      }
    }
  }
  console.log({ bestScale, bestK, minError })
  //*/
  //drawCurve('#ff0000', keys, true, value => {
  //  return chiPDF(value / (sd * bestScale), bestK)
  //})
  //drawCurve('#00ff00', keys, true, value => {
  //  return chiPDF(value / sd, 1.2)
  //})
  if (sources.length > 1) {
    drawCurve('#000000', keys, true, value => {
      return chiPDF(value / (sd * .75), 1.6)
    })
    drawCurve('#00ff00', keys, true, value => {
      return chiPDF(value / sd, 2)
    })
    drawCurve('#0000ff', keys, true, value => {
      return weibullPDF(value / sd, .913, 1.59)
    })
  } else {
    drawCurve('#000000', keys, true, value => {
      return chiPDF(value / sd, 1)
    })
  }

  function drawCurve (style, keys, draw, fn) {
    let totalError = 0
    ctx.strokeStyle = style || '#000000'
    ctx.beginPath()
    ctx.moveTo(0 + boxWidth / 2, canvas.height)
    let max = 0
    for (let i = 0; i < keys.length; ++i) {
      max = Math.max(max, fn(keys[i]))
    }
    for (let i = 0; i < keys.length; ++i) {
      const v = fn(keys[i])
      const y = v / max * 100
      ctx.lineTo(i * boxWidth + 1 + boxWidth / 2, canvas.height - y)
      const box = 100 * (-boxes[keys[i]] / boxMax)
      const error = Math.abs(y) - Math.abs(box)
      totalError += Math.abs(error)
    }
    if (draw) {
      ctx.stroke()
    }
    return totalError
  }

  // Calculate rolling max distance for the last 5 points
  let maxFiveShot = Math.max()
  let minFiveShot = Math.min()
  let maxDistances = [];
  let maxp1
  let maxp2
  if (allPoints.length >= 5) {
    for (let i = 0; i <= allPoints.length - 5; i++) {
      let maxDistance = 0
      for (let j = i; j < i + 5; j++) {
        for (let k = i; k < i + 5; k++) {
          if (j === k) continue
          let distance = Math.sqrt(Math.pow(allPoints[j].x - allPoints[k].x, 2) + Math.pow(allPoints[j].y - allPoints[k].y, 2));
          maxDistance = Math.max(maxDistance, distance);
        }
      }
      minFiveShot = Math.min(minFiveShot, maxDistance)
      maxFiveShot = Math.max(maxFiveShot, maxDistance)
      maxDistances.push(maxDistance)
    }
  }
  let maxDistancesSum = 0
  maxDistances.forEach(d => maxDistancesSum += d)
  let maxDistancesAvg = maxDistancesSum / maxDistances.length
  const averageFiveShotGroup = maxDistancesAvg

  const cep50 = calculateCEPRayleigh(dists, 50)
  const cep95 = calculateCEPRayleigh(dists, 95)
  const cep99 = calculateCEPRayleigh(dists, 99)
  const cep999 = calculateCEPRayleigh(dists, 99.9)

  ;[cep50, cep95, cep99, cep999].forEach(cep => {
    ctx.beginPath();
    ctx.arc(canvas.width / 2, canvas.height / 2, cep * scale, 0, 2 * Math.PI);
    ctx.strokeStyle = 'black';
    ctx.stroke();
    ctx.beginPath();
  })

  return { sd, averageDistance, averageFiveShotGroup, cep50, cep95, cep99, maxFiveShot, minFiveShot, dists, xdists, ydists }
}

export async function simulate (shotCount, runCount, sources, canvas, ctx, scale) {
  let passes = {
    '.01': 0,
    '.05': 0,
    '.1': 0,
    '.2': 0,
  }
  let errors = {
    '.01': 0,
    '.05': 0,
    '.1': 0,
    '.2': 0,
  }
  let replications = {
    '.01': 0,
    '.05': 0,
    '.1': 0,
    '.2': 0,
  }
  let prevPass = {
    '.01': 0,
    '.05': 0,
    '.1': 0,
    '.2': 0,
  }

  let fiveShotTTestPasses = {
    '.01': 0,
    '.05': 0,
    '.1': 0,
    '.2': 0,
  }
  let fiveShotTTestErrors = {
    '.01': 0,
    '.05': 0,
    '.1': 0,
    '.2': 0,
  }
  let fiveShotTTestReplications = {
    '.01': 0,
    '.05': 0,
    '.1': 0,
    '.2': 0,
  }
  let prevFiveTTestShotPass = {
    '.01': 0,
    '.05': 0,
    '.1': 0,
    '.2': 0,
  }

  let fiveShotFTestPasses = {
    '.01': 0,
    '.05': 0,
    '.1': 0,
    '.2': 0,
  }
  let fiveShotFTestErrors = {
    '.01': 0,
    '.05': 0,
    '.1': 0,
    '.2': 0,
  }
  let fiveShotFTestReplications = {
    '.01': 0,
    '.05': 0,
    '.1': 0,
    '.2': 0,
  }
  let prevFiveFTestShotPass = {
    '.01': 0,
    '.05': 0,
    '.1': 0,
    '.2': 0,
  }

  let fiveShotPasses = 0
  let fiveShotErrors = 0
  let fiveShotReplications = 0
  let fiveShotPrevPass = false

  let count = 0

  let beforeSdSum = 0
  let afterSdSum = 0
  let beforeFiveShotSum = 0
  let afterFiveShotSum = 0
  const experimentSources = sources.filter(source => !source.test)
  for (let i = 0; i < runCount; ++i) {
    const beforePoints = []
    const before = drawVectors(canvas, ctx, sources, shotCount, scale, beforePoints)
    beforeSdSum += before.sd
    beforeFiveShotSum += before.averageFiveShotGroup
    await new Promise(resolve => setTimeout(resolve, 1))

    const afterPoints = []
    const after = drawVectors(canvas, ctx, experimentSources, shotCount, scale, afterPoints)
    afterSdSum += after.sd
    afterFiveShotSum += after.averageFiveShotGroup
    await new Promise(resolve => setTimeout(resolve, 1))
    const { p } = mannWhitneyTest(before.dists, after.dists)

    // const mrpp = calculateMRPPpValue(beforePoints, afterPoints, 10000)

    const es_a_s = []
    const es_b_s = []
    for (let i = 0; i < beforePoints.length - 4; i += 5) {
      let a = []
      let b = []
      for (let j = 0; j < 5; ++j) {
        a.push(beforePoints[i + j])
        b.push(afterPoints[i + j])
      }
      const es_a = getFurthestDistance(a)
      const es_b = getFurthestDistance(b)
      es_a_s.push(es_a)
      es_b_s.push(es_b)
    }
    //console.log(es_a_s.join(','), es_b_s.join(','))
    const t = tTest(es_a_s, es_b_s)

    //console.log({ before, after })
    const fx = fTest(before.xdists, after.xdists)
    const fy = fTest(before.ydists, after.ydists)
    //console.log({ xp: fx.p, yp: fy.p })
    //console.log({
    //  sda: standardDeviation(es_a_s),
    //  sdb: standardDeviation(es_b_s),
    //  avga: jStat.mean(es_a_s),
    //  avgb: jStat.mean(es_b_s),
    //  a: es_a_s.join(','),
    //  b: es_b_s.join(','),
    //  p: t.p
    //})

    const es_a_s_avg = es_a_s.reduce((a, b) => a + b, 0) / es_a_s.length
    const es_b_s_avg = es_b_s.reduce((a, b) => a + b, 0) / es_a_s.length
    //console.log({ es_a_s_avg, es_b_s_avg })
    if (es_b_s_avg < es_a_s_avg) {
      ++fiveShotPasses
      if (fiveShotPrevPass) {
        ++fiveShotReplications
      }
      fiveShotPrevPass = true
    } else {
      ++fiveShotErrors
      fiveShotPrevPass = false
    }

    if (before.sd > after.sd) {
      if (t.p < .01) ++fiveShotTTestPasses['.01']
      if (t.p < .05) ++fiveShotTTestPasses['.05']
      if (t.p < .1) ++fiveShotTTestPasses['.1']
      if (t.p < .2) ++fiveShotTTestPasses['.2']
      if (t.p < .01 && prevFiveTTestShotPass['.01']) ++fiveShotTTestReplications['.01']
      if (t.p < .05 && prevFiveTTestShotPass['.05']) ++fiveShotTTestReplications['.05']
      if (t.p < .1 && prevFiveTTestShotPass['.1']) ++fiveShotTTestReplications['.1']
      if (t.p < .2 && prevFiveTTestShotPass['.2']) ++fiveShotTTestReplications['.2']
    } else {
      if (t.p < .01) ++fiveShotTTestErrors['.01']
      if (t.p < .05) ++fiveShotTTestErrors['.05']
      if (t.p < .1) ++fiveShotTTestErrors['.1']
      if (t.p < .2) ++fiveShotTTestErrors['.2']
    }
    prevFiveTTestShotPass['.01'] = p < .01
    prevFiveTTestShotPass['.05'] = p < .05
    prevFiveTTestShotPass['.1'] = p < .1
    prevFiveTTestShotPass['.2'] = p < .2

    if (before.sd > after.sd) {
      if (fx.p < .01 && fy.p < .01) ++fiveShotFTestPasses['.01']
      if (fx.p < .05 && fy.p < .05) ++fiveShotFTestPasses['.05']
      if (fx.p < 0.1 && fy.p < 0.1) ++fiveShotFTestPasses['.1']
      if (fx.p < 0.2 && fy.p < 0.2) ++fiveShotFTestPasses['.2']
      if ((fx.p < .01 && fy.p < .01) && prevFiveFTestShotPass['.01']) ++fiveShotFTestReplications['.01']
      if ((fx.p < .05 && fy.p < .05) && prevFiveFTestShotPass['.05']) ++fiveShotFTestReplications['.05']
      if ((fx.p < 0.1 && fy.p < 0.1) && prevFiveFTestShotPass['.1']) ++fiveShotFTestReplications['.1']
      if ((fx.p < 0.2 && fy.p < 0.2) && prevFiveFTestShotPass['.2']) ++fiveShotFTestReplications['.2']
    } else {
      if (fx.p < .01 || fy.p < .01) ++fiveShotFTestErrors['.01']
      if (fx.p < .05 || fy.p < .05) ++fiveShotFTestErrors['.05']
      if (fx.p < 0.1 || fy.p < 0.1) ++fiveShotFTestErrors['.1']
      if (fx.p < 0.2 || fy.p < 0.2) ++fiveShotFTestErrors['.2']
    }
    prevFiveFTestShotPass['.01'] = fx.p < .01 || fy.p < .01
    prevFiveFTestShotPass['.05'] = fx.p < .05 || fy.p < .05
    prevFiveFTestShotPass['.1']  = fx.p < 0.1 || fy.p < 0.1
    prevFiveFTestShotPass['.2']  = fx.p < 0.2 || fy.p < 0.2

    if (before.sd > after.sd) {
      if (p < .01) ++passes['.01']
      if (p < .05) ++passes['.05']
      if (p < .1) ++passes['.1']
      if (p < .2) ++passes['.2']
      if (p < .01 && prevPass['.01']) ++replications['.01']
      if (p < .05 && prevPass['.05']) ++replications['.05']
      if (p < .1 && prevPass['.1']) ++replications['.1']
      if (p < .2 && prevPass['.2']) ++replications['.2']
    } else {
      if (p < .01) ++errors['.01']
      if (p < .05) ++errors['.05']
      if (p < .1) ++errors['.1']
      if (p < .2) ++errors['.2']
    }
    prevPass['.01'] = p < .01
    prevPass['.05'] = p < .05
    prevPass['.1'] = p < .1
    prevPass['.2'] = p < .2
    ++count
  }
  const passRate = {
    '.01': (100 * (passes['.01'] / count)).toFixed(1) + '%',
    '.05': (100 * (passes['.05'] / count)).toFixed(1) + '%',
    '.1': (100 * (passes['.1'] / count)).toFixed(1) + '%',
    '.2': (100 * (passes['.2'] / count)).toFixed(1) + '%',
  }
  const errorRate = {
    '.01': (100 * (errors['.01'] / count)).toFixed(1) + '%',
    '.05': (100 * (errors['.05'] / count)).toFixed(1) + '%',
    '.1': (100 * (errors['.1'] / count)).toFixed(1) + '%',
    '.2': (100 * (errors['.2'] / count)).toFixed(1) + '%',
  }
  const replicationRate = {
    '.01': (100 * (replications['.01'] / count)).toFixed(1) + '%',
    '.05': (100 * (replications['.05'] / count)).toFixed(1) + '%',
    '.1': (100 * (replications['.1'] / count)).toFixed(1) + '%',
    '.2': (100 * (replications['.2'] / count)).toFixed(1) + '%',
  }
  const fiveShotTTestPassRate = {
    '.01': (100 * (fiveShotTTestPasses['.01'] / count)).toFixed(1) + '%',
    '.05': (100 * (fiveShotTTestPasses['.05'] / count)).toFixed(1) + '%',
    '.1': (100 * (fiveShotTTestPasses['.1'] / count)).toFixed(1) + '%',
    '.2': (100 * (fiveShotTTestPasses['.2'] / count)).toFixed(1) + '%',
  }
  const fiveShotTTestErrorRate = {
    '.01': (100 * (fiveShotTTestErrors['.01'] / count)).toFixed(1) + '%',
    '.05': (100 * (fiveShotTTestErrors['.05'] / count)).toFixed(1) + '%',
    '.1': (100 * (fiveShotTTestErrors['.1'] / count)).toFixed(1) + '%',
    '.2': (100 * (fiveShotTTestErrors['.2'] / count)).toFixed(1) + '%',
  }
  const fiveShotTTestReplicationRate = {
    '.01': (100 * (fiveShotTTestReplications['.01'] / count)).toFixed(1) + '%',
    '.05': (100 * (fiveShotTTestReplications['.05'] / count)).toFixed(1) + '%',
    '.1': (100 * (fiveShotTTestReplications['.1'] / count)).toFixed(1) + '%',
    '.2': (100 * (fiveShotTTestReplications['.2'] / count)).toFixed(1) + '%',
  }
  const fTestPassRate = {
    '.01': (100 * (fiveShotFTestPasses['.01'] / count)).toFixed(1) + '%',
    '.05': (100 * (fiveShotFTestPasses['.05'] / count)).toFixed(1) + '%',
    '.1': (100 * (fiveShotFTestPasses['.1'] / count)).toFixed(1) + '%',
    '.2': (100 * (fiveShotFTestPasses['.2'] / count)).toFixed(1) + '%',
  }
  const fTestErrorRate = {
    '.01': (100 * (fiveShotFTestErrors['.01'] / count)).toFixed(1) + '%',
    '.05': (100 * (fiveShotFTestErrors['.05'] / count)).toFixed(1) + '%',
    '.1': (100 * (fiveShotFTestErrors['.1'] / count)).toFixed(1) + '%',
    '.2': (100 * (fiveShotFTestErrors['.2'] / count)).toFixed(1) + '%',
  }
  const fTestReplicationRate = {
    '.01': (100 * (fiveShotFTestReplications['.01'] / count)).toFixed(1) + '%',
    '.05': (100 * (fiveShotFTestReplications['.05'] / count)).toFixed(1) + '%',
    '.1': (100 * (fiveShotFTestReplications['.1'] / count)).toFixed(1) + '%',
    '.2': (100 * (fiveShotFTestReplications['.2'] / count)).toFixed(1) + '%',
  }
  console.log({ fiveShotPasses, fiveShotReplications, fiveShotErrors, count })
  const fiveShotPassRate = (100 * (fiveShotPasses / count)).toFixed(1) + '%'
  const fiveShotReplicationRate = (100 * (fiveShotReplications / count)).toFixed(1) + '%'
  const fiveShotErrorRate = (100 * (fiveShotErrors / count)).toFixed(1) + '%'
  const beforeSdAvg = (beforeSdSum / count).toFixed(3)
  const afterSdAvg = (afterSdSum / count).toFixed(3)
  const beforeFiveShotAvg = (beforeFiveShotSum / count).toFixed(3)
  const afterFiveShotAvg = (afterFiveShotSum / count).toFixed(3)
  return {
    passRate,
    replicationRate,
    errorRate,
    fiveShotTTestPassRate,
    fiveShotTTestReplicationRate,
    fiveShotTTestErrorRate,
    fTestPassRate,
    fTestReplicationRate,
    fTestErrorRate,
    fiveShotPassRate,
    fiveShotReplicationRate,
    fiveShotErrorRate,
    beforeSdAvg,
    afterSdAvg,
    beforeFiveShotAvg,
    afterFiveShotAvg
  }
}
